export default "__VITE_ASSET__DhwmOO4O__"